var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashHistoryImahe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.1538C0 8.53885 0 4.73135 2.36568 2.36568C4.73135 0 8.53885 0 16.1538 0H18.8462C26.4612 0 30.2687 0 32.6343 2.36568C35 4.73135 35 8.53885 35 16.1538V18.8462C35 26.4612 35 30.2687 32.6343 32.6343C30.2687 35 26.4611 35 18.8462 35H16.1538C8.53885 35 4.73135 35 2.36568 32.6343C0 30.2687 0 26.4611 0 18.8462V16.1538Z",
    fill: "url(#paint0_linear_5_4979)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1282 16.8269H21.9872C20.8415 16.8269 20.1923 17.4761 20.1923 18.6218V21.7628C20.1923 22.9056 20.8385 23.5577 21.9872 23.5577H25.1282C26.2739 23.5577 26.9231 22.9056 26.9231 21.7628V18.6218C26.9231 17.4761 26.2739 16.8269 25.1282 16.8269Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2339 20.5499H23.9361V21.8365C23.9361 22.0436 23.7667 22.2115 23.5577 22.2115C23.3487 22.2115 23.1793 22.0436 23.1793 21.8365V20.5499H21.8815C21.6866 20.5299 21.5385 20.367 21.5385 20.1728C21.5385 19.9785 21.6866 19.8157 21.8815 19.7957H23.1753V18.5131C23.1954 18.3199 23.3597 18.1731 23.5557 18.1731C23.7516 18.1731 23.9159 18.3199 23.9361 18.5131V19.7957H25.2339C25.4288 19.8157 25.5769 19.9785 25.5769 20.1728C25.5769 20.367 25.4288 20.5299 25.2339 20.5499Z",
    fill: "url(#paint1_linear_5_4979)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0962 15.4808C10.0962 13.577 10.0962 12.6251 10.6876 12.0337C11.279 11.4423 12.2309 11.4423 14.1346 11.4423H20.8654C22.7691 11.4423 23.721 11.4423 24.3124 12.0337C24.9038 12.6251 24.9038 13.577 24.9038 15.4808V16.1538H21.6731C20.2982 16.1538 19.5192 16.9328 19.5192 18.3077V21.5385H14.1346C12.2309 21.5385 11.279 21.5385 10.6876 20.947C10.0962 20.3556 10.0962 19.4037 10.0962 17.5V15.4808Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0962 14.1346H24.9038V16.1538H10.0962V14.1346Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_4979",
    x1: 17.5,
    y1: 0,
    x2: 17.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D172A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_4979",
    x1: 17.5,
    y1: 0,
    x2: 17.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D172A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashHistoryImahe);
export default __webpack_public_path__ + "static/media/CashHistoryImahe.9ecfc69d70c05b8688dba05ff64de58a.svg";
export { ForwardRef as ReactComponent };